const defaultSkeletonRows = ['first', 'second'];

export default function SkeletonCard({ skeletonRows = defaultSkeletonRows }:{ readonly skeletonRows?: string[]}) {
  return (
    <output
      className="flex flex-col grow min-w-37.5 flex-1 card font-normal animate-pulse motion-reduce:animate-none"
      aria-label="Loading impact card"
    >
      <div className="flex justify-between items-center p-2">
        <div className="h-4 w-28 rounded bg-pipgrey-light" />
        <div className="h-5 w-5 rounded bg-pipgrey-light" />
      </div>
      <div className="flex-1" aria-hidden="true">
        {skeletonRows.map((row) => (
          <div key={row} className="flex flex-col p-2 gap-3 first:border-t last:border-none border-b border-pipgrey-light">
            <div className="h-3 w-3/4 rounded bg-pipgrey-light" />
            <div className="h-6 w-1/3 rounded bg-pipgrey-light" />
            <div className="h-3 w-full rounded bg-pipgrey-light" />
          </div>
        ))}
      </div>
      <span className="sr-only">Loading card</span>
    </output>
  );
}
